"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withHttpError = void 0;
const react_1 = __importStar(require("react"));
const http_1 = require("@utils/http");
const config_1 = require("@app/config");
const withHttpError = (WrappedComponent) => {
    return (props) => {
        (0, react_1.useEffect)(() => {
            http_1.FetchInterceptor.register({
                request: (request) => {
                    var _a;
                    if (request.url.match && request.url.match(config_1.CONFIG.baseApiUrl) && request.config) {
                        const requestHeaders = ((_a = request.config) === null || _a === void 0 ? void 0 : _a.headers) || new Headers();
                        requestHeaders.append("Content-Type", "application/json");
                        request.config.headers = requestHeaders;
                    }
                    return request;
                },
                response: (response) => {
                    if (response.status >= 400) {
                        throw new Error("Negative status code:" + response.status);
                    }
                    return response;
                },
            });
        }, []);
        return react_1.default.createElement(WrappedComponent, Object.assign({}, props));
    };
};
exports.withHttpError = withHttpError;
